import { object } from 'prop-types'
import { connect } from 'react-redux'
import PresentationsHeader from '.'

export const PresentationHeaderComponent = (props) => {
  const {
    logo,
    logo_alignment: logoAlignment,
    header_background_color: headerBackgroundColor,
  } = props.presentationHeaderTheme

  return (
    <PresentationsHeader
      className="presentation-header"
      logo={logo}
      logoAlignment={logoAlignment}
      headerBackgroundColor={headerBackgroundColor}
      editControlsText="hide-edit-controls-text"
    />
  )
}

PresentationHeaderComponent.propTypes = {
  presentationHeaderTheme: object,
}

const mapStateToProps = (state, props) => ({
  presentationHeaderTheme: props.theme || {},
})

const ConnectedPresentationHeader = connect(mapStateToProps)(
  PresentationHeaderComponent
)

export default ConnectedPresentationHeader
